import type {
  CompositionV3Ent,
  PostingsV3Ent,
  TransitionsV3Ent,
} from '@revelio/data-access';

import {
  type Filter,
  FilterType,
  type PrimaryFilterId,
  type TreeSelection,
} from '../types/filters';
import { getNumericIdFromNestedId } from './get-numeric-id-from-nested-id';
import {
  getEntKindForGeoOrRicsLevelId,
  getEntKindForRoleLevelId,
  getEntKindForSkillLevelId,
} from './role-skill-ent-kind';

type V3Ent = CompositionV3Ent | TransitionsV3Ent | PostingsV3Ent;

const resolveV3EntForSelection = (selection: TreeSelection): V3Ent | null => {
  const levelId = selection.levelId;

  const entKind =
    getEntKindForGeoOrRicsLevelId(levelId) ??
    getEntKindForRoleLevelId(String(selection.levelId)) ??
    getEntKindForSkillLevelId(String(selection.levelId));
  if (!entKind) return null;

  const id = getNumericIdFromNestedId(selection.id);
  if (id === null) return null;

  return { EntType: entKind, EntID: id };
};

export const getV3Entities = ({
  primaryDimension,
  filters,
}: {
  primaryDimension: PrimaryFilterId;
  filters: Filter[];
}): CompositionV3Ent[] | TransitionsV3Ent[] | PostingsV3Ent[] => {
  const primaryFilter = filters.find(
    (filter) => filter.id === primaryDimension
  );

  if (!primaryFilter || primaryFilter.type !== FilterType.TREE) return [];

  return primaryFilter.selections
    .map(resolveV3EntForSelection)
    .filter((selection) => selection !== null);
};
